import { Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { createGlobalStyle } from 'styled-components';
import defaultImage from '../../static/images/defaultImage.png';
import { withTheme } from '@mui/styles';
import CurrencyDisplay from '../common/CurrencyDisplay';

const GlobalStyle = createGlobalStyle`
  .menu {
    display: grid;
    gap: 10px;

    .menu-picture {
      text-align: center;
    }

    .menu-name {
      font-weight: bold;
    }
  }

  .menu-button-group {
    display: grid;
    gap: 20px;
    margin-top: 20px;

    .menu-button {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
  }
`;

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class SetItemModal extends Component {
  state = {
    menu: null,
    menuPriceInfo: null,
    linkMenuPriceInfo: null,
  };

  componentDidMount() {
    const { menuStore } = this.props;
    this.setState({
      menu: menuStore.selectedMenu,
      menuPriceInfo: menuStore.getMenuPriceInfo(menuStore.selectedMenu),
      linkMenuPriceInfo: menuStore.getMenuPriceInfo(menuStore.selectedMenu.linkMenu),
    });
    menuStore.setSelectedMenu(null);
  }

  handleMenuClick = () => {
    const { location, history, commonStore, menuStore } = this.props;
    menuStore.closeSetItemModal();
    history.push(
      `/${commonStore.companyId}/${commonStore.storeCode}/menu-groups/${this.state.menu.groupCode}/menus/${this.state.menu.itemCode}${location.search}`,
    );
  };

  handleSetClick = () => {
    const { location, history, commonStore, menuStore } = this.props;
    menuStore.closeSetItemModal();
    history.push(
      `/${commonStore.companyId}/${commonStore.storeCode}/menus/${this.state.menu.linkMenu.itemCode}${location.search}`,
    );
  };

  closeSetItemModal = () => {
    this.props.menuStore.closeSetItemModal();
  };

  render() {
    const { i18n, menuStore } = this.props;

    if (!menuStore.isSetItemModalOpen || !this.state.menu) return null;
    return (
      <>
        <GlobalStyle />
        <Dialog open={menuStore.isSetItemModalOpen} maxWidth="lg" onClose={this.closeSetItemModal}>
          <DialogTitle
            sx={{ backgroundColor: theme => theme.palette.primary.main, color: 'white', textAlign: 'center' }}
          >
            {i18n.t('menu.title.singleSetSelect')}
          </DialogTitle>
          <DialogContent sx={{ marginTop: '20px' }}>
            <div className="menu">
              <div className="menu-picture">
                <img
                  src={menuStore.getImageUrl(
                    this.state.menu.itemStoreCode,
                    this.state.menu.pictureFileName1,
                    this.state.menu.pictureFileName2,
                  )}
                  alt={this.state.menu.name}
                  height="140px"
                  onError={e => (e.target.src = defaultImage)}
                  style={{ maxWidth: '100%' }}
                />
              </div>
              <div className="menu-name">{this.state.menu.name}</div>

              {this.state.menu.memo && (
                <div className="menu-memo">
                  {this.state.menu.memo.split('\n').map((text, index) => {
                    return (
                      <span key={index}>
                        {text}
                        <br />
                      </span>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="menu-button-group">
              <div className="menu-button">
                <Button
                  variant="contained"
                  sx={{ height: '100px', whiteSpace: 'normal' }}
                  onClick={this.handleMenuClick}
                >
                  <Typography>
                    {i18n.t('menu.label.single')}
                    <br />
                    <CurrencyDisplay amount={this.state.menuPriceInfo.discountedAmount} />
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  sx={{ height: '100px', whiteSpace: 'normal' }}
                  onClick={this.handleSetClick}
                >
                  <Typography>
                    {i18n.t('menu.label.set')}
                    <br />
                    <CurrencyDisplay amount={this.state.linkMenuPriceInfo.discountedAmount} />
                  </Typography>
                </Button>
              </div>
              <Button variant="outlined" color="error" size="large" onClick={this.closeSetItemModal}>
                {i18n.t('common.button.cancel')}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default withTranslation()(withRouter(withTheme(SetItemModal)));
